import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { CvInput } from "./ApplyDialog";

const STEPS = ["received", "under_review", "shortlisted", "interview", "decision"];
const LABEL = { received: "Received", under_review: "Under review", shortlisted: "Shortlisted", interview: "Interview", decision: "Decision" };

export const TrackApp = () => {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [app, setApp] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try {
      setApp((await api.get("/public/applications/track", { params: { code, email } })).data);
    } catch (err) {
      setApp(null);
      toast.error(errMsg(err));
    }
  };
  const idx = app ? STEPS.indexOf(app.status.startsWith("decision") ? "decision" : app.status) : -1;
  return (
    <div className="panel p-6" data-testid="track-application">
      <div className="eyebrow mb-2">Track your application</div>
      <form onSubmit={submit} className="grid sm:grid-cols-3 gap-3">
        <input required className="field" placeholder="DGC-XXXXXX" value={code} onChange={(e) => setCode(e.target.value)} data-testid="track-code-input" />
        <input required type="email" className="field" placeholder="Email used" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="track-email-input" />
        <button className="btn-gold" data-testid="track-submit-btn">Check status</button>
      </form>
      {app && (
        <div className="mt-6" data-testid="track-result">
          <div className="text-ink font-semibold">{app.job_title} <span className="text-slate-500 text-sm">· applied {fmtDate(app.created_at)}</span></div>
          <div className="grid grid-cols-5 gap-1 mt-4">
            {STEPS.map((s, i) => (
              <div key={s}>
                <div className={`h-1.5 rounded-full ${i <= idx ? "bg-gold" : "bg-slate-700"}`} />
                <div className={`font-data text-[10px] mt-2 uppercase ${i <= idx ? "text-gold" : "text-slate-500"}`}>{LABEL[s]}</div>
              </div>
            ))}
          </div>
          <div className="text-sm text-slate-300 mt-3" data-testid="track-status">Current: {app.status.replace("_", " ").replace("decision_", "decision: ")}</div>
        </div>
      )}
    </div>
  );
};

export const TalentPool = () => {
  const [f, setF] = useState({ name: "", email: "", phone: "", skills: "", interests: "Media", languages: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, v));
    fd.append("alerts", "true");
    if (file) fd.append("cv", file);
    try {
      toast.success((await api.post("/public/talent-pool", fd)).data.message);
      setF({ ...f, name: "", email: "", phone: "", skills: "" });
      setFile(null);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="panel p-6 grid gap-3" data-testid="talent-pool-form">
      <div className="eyebrow">Join the talent community</div>
      <p className="text-sm text-slate-400">No matching role yet? Drop your CV and we'll alert you when one opens.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <input required className="field" placeholder="Full name" value={f.name} onChange={set("name")} data-testid="pool-name" />
        <input required type="email" className="field" placeholder="Email" value={f.email} onChange={set("email")} data-testid="pool-email" />
        <input className="field" placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="pool-phone" />
        <select className="field" value={f.interests} onChange={set("interests")} data-testid="pool-interest">
          {["Media", "Newsroom", "Production", "Digital", "Food & Beverages", "Finance", "Hospitality", "Operations"].map((x) => <option key={x}>{x}</option>)}
        </select>
      </div>
      <input className="field" placeholder="Skills (comma separated: video editing, Twi presenting…)" value={f.skills} onChange={set("skills")} data-testid="pool-skills" />
      <input className="field" placeholder="Languages" value={f.languages} onChange={set("languages")} data-testid="pool-languages" />
      <CvInput file={file} setFile={setFile} testId="pool-cv-input" />
      <button disabled={busy} className="btn-gold" data-testid="pool-submit-btn">{busy ? "Saving…" : "Join & get job alerts"}</button>
    </form>
  );
};
